import React, { useState } from "react";
import { Box, Button, Stack } from "@mui/joy";
import RecordPausebtn from "../../assets/svgs/recordpausebtn.svg";
import RecordStartbtn from "../../assets/svgs/recordstartbtn.svg";
import { buttonStyles } from "./CameraButtonStyles";
import CountdownTimer from "./CountDownTimer";
import "../../index.css"

interface CameraControlsProps {
  isRecording: boolean;
  hasRecording: boolean;
  videoBlob: Blob | null;
  onStartRecording: () => void;
  onProceed: () => void;
}

const CameraControls: React.FC<CameraControlsProps> = ({
  isRecording,
  onStartRecording,
  onProceed,
}) => {
  const [showCountdown, setShowCountdown] = useState(false);

  const handleRecordButtonClick = () => {
    if (isRecording) {
      onProceed();
    } else if (showCountdown) {
      setShowCountdown(false);
    } else {
      setShowCountdown(true);
    }
  };

  const handleCountdownComplete = () => {
    setShowCountdown(false);
    onStartRecording();
  };

  return (
    <>
      <CountdownTimer
        isActive={showCountdown}
        onComplete={handleCountdownComplete}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 32,
          left: 0,
          right: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none",
        }}
      >
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ position: "relative", width: "100%", pointerEvents: "auto" }}
        >
          <Button
            onClick={handleRecordButtonClick}
            variant="plain"
            sx={buttonStyles.recordButton}
            className={showCountdown ? "record-button-pulsing" : ""}
            style={{ zIndex: 25 }}
          >
            <img
              src={isRecording ? RecordStartbtn : RecordPausebtn}
              alt="record"
              className="w-12 h-12"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              style={{ pointerEvents: "none" }}
            />
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default CameraControls;
